"use client";

import React, { useEffect } from 'react';
import './Step5.css';
import PropTypes from 'prop-types';
import { ReactComponent as Chat } from '../../../assets/img/Chat.svg';
import { ReactComponent as Confirm } from '../../../assets/img/Confirm.svg';
import { Link, useNavigate } from 'react-router-dom';
import { getToken, removeSinisterType, removeToken, removeValidateType, } from '../../../utils/claimManager';
import useSiniestrosStore from '../../../store/siniestrosStore';
import { Loader } from '../../../components';
import { Button, Icon } from 'atm-global-stylish/dist';
import { copyText, isEmpty, scrollToTop } from '../../../utils/functions';

const Step5 = ({ loader, instance, clearInstance, getInstance, urlStatus }) => {
	const { loading } = useSiniestrosStore();
	const navigate = useNavigate();

	useEffect(() => {
		const token = getToken();
		getInstance(token);
		if (!token) {
			clearInstance();
			navigate('/')
		}
	}, []);

	const handleBack = () => {
		scrollToTop();
		clearInstance();
		removeSinisterType();
		removeToken();
		removeValidateType();
		navigate('/')
	}

	const IconCopy = () => {
		return (
			<div className='hover:bg-opacity-50 bg-shiny-pink-lighter p-1 border border-primary rounded-md w-min cursor-pointer' onClick={() => {
				(async () => {
					await copyText(urlStatus);
				})();
			}}>
				<Icon.Copy size={20} color={'#7C1338'} />
			</div>
		);
	}

	if (loading || loader) return <Loader />;

	return (
		<div className='step5 w-full md:w-1/2 m-auto my-8 px-5 md:px-0 justify-center items-center flex flex-col'>
			<Confirm className='w-25 mx-auto mb-8 md:mb-4' />
			<div className='w-full flex flex-col text-center'>
				<p className='text-2xl md:text-4xl text-red font-normal leading-normal'>Le informamos que su solicitud ha sido registrada bajo el número: <b>{instance?.claim_number}</b>.</p>
			</div>
			<Chat className='w-22 mx-auto my-9 md:my-14' />
			<div className='w-full flex flex-col text-center mb-8 md:mb-12 md:gap-1'>
				<p className='text-xl md:text-2xl text-red font-normal leading-normal'>Enviamos un correo electrónico con la confirmación.</p>
				<p className='text-xl md:text-2xl text-red font-bold leading-normal'>El plazo estimado de analisis es de 30 dias.</p>
			</div>
			{
				!isEmpty(urlStatus) ?
					<div className='w-full flex flex-col text-center mb-8 md:mb-12 md:gap-1 bg-neutral rounded-lg p-6 border border-primary'>
						<p className='text-xl md:text-2xl text-red font-normal leading-normal'>Visualizá el avance de tu reclamo desde el siguiente link:</p>
						<div className="flex flex-row gap-x-2 justify-center">
							<Link className='text-primary text-xl md:text-2xl font-bold' to={urlStatus} target='_blank'>{urlStatus}</Link>
							<IconCopy />
						</div>
						<p className='text-xl md:text-2xl text-red font-normal leading-normal'>Recordá guardarlo para futuras consultas.</p>
					</div>
					:
					<></>
			}
			<div className='w-full flex flex-col text-center md:gap-1'>
				<p className='text-xl md:text-2xl text-red font-normal leading-normal'>Luego, nos pondremos en contacto informando resolución.</p>
				<p className='text-xl md:text-2xl text-red font-normal leading-normal'>Gracias.</p>
			</div>
			<Button type='secondary' title='Volver al inicio' handleClick={handleBack} className='p-2 md:p-3 mx-auto self-center border border-primary mt-10' />
		</div>
	);
};

Step5.propTypes = {
	reset: PropTypes.func
};

export default Step5;